import { module } from 'modujs';
import { gsap } from 'gsap';
export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close',
                background: 'close',
                button: 'openPopup',

            }
        }
    }

    init() {
        // Check if user has already seen the popin
        if (sessionStorage.getItem('hasSeenPopin')) {
            return;
        } else {

          gsap.delayedCall(2, () => {
            this.open();
          });
        }

    }

    openPopup(e) {
        let slug = e.currentTarget.getAttribute('data-slug');        
        this.call('open',{},'Popup',slug);
    }

    open() {
                
        // Continue with popin opening logic
        this.el.classList.add('is-active');
    }

    close() {
        // Mark that user has seen the popin
        sessionStorage.setItem('hasSeenPopin', 'true');
        this.el.classList.remove('is-active');
    }
}
